import React from 'react';

import { FormattedMessage } from '@futrli/localisation';

import * as styles from './row-formula.scss';

interface RowFormulaErrorProps {
  formulaErrorCode?: string;
  isValidFormula: boolean;
  touched: boolean;
}

export const RowFormulaError = ({ formulaErrorCode, isValidFormula, touched }: RowFormulaErrorProps) => {
  if (!touched || (isValidFormula && !formulaErrorCode)) {
    return null;
  }

  return (
    <div className={styles.formulaErrorCarbon}>
      {!isValidFormula ? (
        <FormattedMessage
          id="predict.keep_editing_formula_not_ready"
          defaultMessage="Keep editing - your formula is not yet ready to be saved."
        />
      ) : formulaErrorCode === 'ERROR_CIRCULAR_REFERENCE' ? (
        <FormattedMessage
          id="predict.formula_error_circular_reference"
          defaultMessage="Your formula cannot be saved, as it will create a circular reference."
        />
      ) : (
        <FormattedMessage
          id="predict.formula_error_error"
          defaultMessage="Your formula cannot be saved, it contains an error."
        />
      )}
    </div>
  );
};
